import {
  IElementCategory,
  ElementCategoryID,
} from '../../../models/element-categories.model';
import { omit } from '../../../helpers/object.helpers';
import {
  DEFAULT_QUANTITY_EXPRESSIONS,
  DEFAULT_QUANTITY_PROPERTIES,
} from '../../../models/element-quantities.model';
import { thermalTransmittanceProperty } from '../properties';
import { windowsDoorsProperties } from './windows-doors-properties';
import { ElementKind } from '../../../models/project.model';
import {
  getElementPropertySelectionByValue,
  getValueFromConditionalNodes,
} from '../../../helpers/conditional-nodes.helpers';
import { windowProductIds } from './windows-doors-product-ids';
import { ProductID } from '../../../models/product.model';

const optionalProperties: IElementCategory['optionalProperties'] = [
  {
    ...thermalTransmittanceProperty,
    fallbackCount: 1.05,
  },
];

export const windowsDoors: IElementCategory = {
  id: ElementCategoryID.WindowsDoors,
  name: 'Windows & Doors',
  color: '#D3A1BF',
  defaultSelectedQuantity: 'mass',
  properties: windowsDoorsProperties,
  optionalProperties,
  getQuantityProperties: () => ({
    ...omit(DEFAULT_QUANTITY_PROPERTIES, 'density'),
    density_areal_side: {
      fallbackCount: DEFAULT_QUANTITY_EXPRESSIONS.density_areal_side,
    },
  }),

  // `throwIfNotFound: false` + `undefined` return: same resilience pattern as
  // the other product categories — a transient Select count that the
  // conditional tree cannot map should skip enrichment (preserving existing
  // children) rather than strip them.
  getChildElements: (element) => {
    const productId = getValueFromConditionalNodes(
      element,
      [windowProductIds],
      false,
    );
    if (!productId) return undefined;
    return [
      {
        kind: ElementKind.Product,
        count: 'mass',
        unit: 'kg',
        product_id: productId,
      },
    ];
  },
  getElementPropertySelectionByProductId: (productId: ProductID) =>
    getElementPropertySelectionByValue(productId, windowProductIds),
};
